// extracted by mini-css-extract-plugin
module.exports = {"root":"ReviewStats-module__root___AzOI9","reviewsCount":"ReviewStats-module__reviewsCount___JydCy"};